import { createContext, useContext, useState } from 'react';
export const MatchingContext = createContext({
  matchHintModal: {
    isVisible: false
  },
  setMatchHintModal: () => null
});
export const MatchingProvider = ({
  children
}) => {
  const [matchHintModal, setMatchHintModal] = useState({
    isVisible: false
  });
  return <MatchingContext.Provider value={{
    matchHintModal,
    setMatchHintModal
  }}>
      {children}
    </MatchingContext.Provider>;
};
export const useMatching = () => useContext(MatchingContext);